<template>
  <div class="container-box">
    <h2 class="title-type-1">매체 등록</h2>

    <ul class="progress-step mb-10">
      <li class="complete">
        <p class="state">
          <span class="check">
            <v-icon>mdi-check</v-icon>
          </span>
        </p>
        <p class="text">매체 기본정보</p>
      </li>
      <li class="active">
        <p class="state">
          <span class="num">2</span>
        </p>
        <p class="text">지면 등록</p>
      </li>
    </ul>

    <div class="search-box-1 mb-n3 pb-5">
      <div></div>
      <div class="btn">
        <span class="attention-coment-1 mr-4">
          <v-icon>mdi-alert-circle</v-icon>
          세팅할 지면 클릭시 세부 소재 개수, 규격, 옵션값 세팅 메뉴에서 설정
          가능합니다.
        </span>
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1"
          @click.prevent="showMediaInventoriesModal = true"
        >
          <v-icon left> mdi-plus </v-icon>
          지면 추가
        </v-btn>
      </div>
    </div>

    <p class="text-total-1 mb-3">
      총 <strong>{{ boardLists.length || 0 }}</strong
      >건 입니다.
    </p>
    <div class="table-wrap" style="position: relative">
      <v-data-table
        :headers="boardHeaders"
        :items="customBoardLists"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        class="board-list-1"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:item.name="{ item }">
          <a
            href="javascript:void(0);"
            @click.prevent="getDetailInventory(item.id)"
          >
            {{ item.name }}
          </a>
        </template>

        <template v-slot:item.is_valid="{ item }">
          <v-switch
            inset
            hide-details
            color="#fecd00"
            :input-value="item.is_valid === 'Y' ? true : false"
            :label="item.is_valid === 'Y' ? '운영중' : '개발중'"
            class="switch-type-1 mt-0"
            @change="isValidPopup(item)"
          ></v-switch>
        </template>

        <template v-slot:item.options="{ item }">
          <span v-for="(opt, index) in item.options" :key="index" class="tag">
            <v-tooltip right content-class="tooltip-custom-1">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">{{ opt.name }}</span>
              </template>
              <span>{{ optionTooltip(opt.id) }}</span>
            </v-tooltip>
          </span>
        </template>

        <template v-slot:item.modify="{ item }">
          <!--<a href="" @click.prevent="onModifyPopup(item)">
						{{ item.modify }}
					</a>-->
          <a
            href=""
            @click.prevent="onModifyPopup(item)"
            style="color: transparent"
          >
            <v-icon color="#fecd00">mdi-cog-outline</v-icon>
          </a>
        </template>

        <template v-slot:no-data>
          <div class="text-center">
            등록된 지면이 없습니다. 우측상단 지면추가 버튼을 클릭후 지면을
            추가해주세요.
          </div>
        </template>
      </v-data-table>
    </div>
    <div class="pagination-1">
      <div class="sel-sort">
        <span>페이지당 행개수</span>
        <v-select
          :items="pageSel"
          :label="pageSel[0]"
          v-model="pageSelChoice"
          item-color="#000"
          class="input-custom-1"
          height="40px"
          solo
          @change="itemsPerPage = parseInt($event, 10)"
        ></v-select>
      </div>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == 1"
        @click="page = 1"
      >
        <v-icon>mdi-page-first</v-icon>
      </v-btn>

      <v-pagination
        v-model="page"
        :length="pageCount"
        total-visible="10"
        color="transparent"
      ></v-pagination>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == pageCount"
        @click="page = pageCount"
      >
        <v-icon>mdi-page-last</v-icon>
      </v-btn>

      <div class="btn-box">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1"
          @click.prevent="$router.push('/media')"
        >
          완료
        </v-btn>
      </div>
    </div>

    <div class="mt-16" v-if="detailInventory">
      <h3 class="title-type-2">
        <strong>{{ detailInventory.name }}</strong>
        지면 세부
      </h3>

      <h4 class="title-type-3">
        지면 기본 정보
        <span class="attention-coment-1 ml-2">
          <v-icon>mdi-alert-circle</v-icon>
          관리자의 경우 조회 옵션을 먼저 선택해야합니다.
        </span>
      </h4>
      <div class="relative white rounded pa-6 pr-16">
        <div class="form-row-2">
          <div>
            <p class="tit">생성일자</p>
            <p class="val">
              {{ detailInventory.create_at | moment('YYYY.MM.DD HH:mm:ss') }}
            </p>
          </div>
          <div>
            <p class="tit">생성 관리자</p>
            <p class="val">{{ detailInventory.creator.manager_name || '-' }}</p>
          </div>
          <div>
            <p class="tit">동시 노출 광고 수</p>
            <p class="val">{{ detailInventory.overlap_cnt }}</p>
          </div>
          <div>
            <p class="tit">광고 API키 값</p>
            <p class="val">
              <span>{{ detailInventory.id }}</span>
              <v-tooltip right content-class="tooltip-custom-1">
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    @click.stop.prevent="copyTestingCode(detailInventory.id)"
                    style="font-size: 18px; padding-left: 8px"
                  >
                    mdi-content-copy
                  </v-icon>
                </template>
                Copy
              </v-tooltip>
            </p>
          </div>
        </div>
      </div>
    </div>

    <MediaInventoriesModal
      v-model="showMediaInventoriesModal"
      :inventoriesOptions="options"
      :mediaType="mediaType"
      @refreshList="getListInventory"
    />

    <MediaInventoriesModifyModal
      v-model="showMediaInventoriesModifyModal"
      :inventories="inventoriesProps"
      :inventoriesOptions="options"
      @refreshList="getListInventory"
      @cancelProps="inventoriesProps = null"
    />

    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
    <input type="hidden" id="testing-code" value="" />
  </div>
</template>

<script>
import bus from '@/utils/bus';
import { detailMedia, listMediaInventories } from '@/api/media';
import { detailInventory, updateInventory } from '@/api/inventory';
import { optionsList } from '@/api/options';
import MediaInventoriesModal from '~@/modal/MediaInventoriesModal';
import MediaInventoriesModifyModal from '~@/modal/MediaInventoriesModifyModal';

import SystemAlert from '~@/modal/SystemAlert';

export default {
  components: {
    MediaInventoriesModal,
    MediaInventoriesModifyModal,
    SystemAlert,
  },
  data: () => ({
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    boardHeaders: [
      { text: 'No', value: 'no', width: '7%', sortable: false },
      { text: '지면 명', value: 'name', sortable: false },
      {
        text: '선택 지면 옵션',
        value: 'options',
        width: '30%',
        sortable: false,
      },
      { text: '지면 설명', value: 'note', width: '18%', sortable: false },
      { text: '지면 상태', value: 'is_valid', width: '16%', sortable: false },
      { text: '관리', value: 'modify', width: '7%', sortable: false },
    ],
    boardLists: [],
    mediaType: '',
    inventoryTooltip: [
      '모드별 구분 설정',
      '코스별 지면 설정',
      '1~18번 홀까지 상품(지면) 설정',
      '같은 지면내 동시 노출 수 제한 설정',
      '영상 광고  필요시 설정',
      '이미지 배너 광고 필요시 설정',
    ],
    inventoriesProps: null,
    options: [],
    detailOptoins: [],
    detailOptoinsNone: [],
    showMediaInventoriesModal: false,
    showMediaInventoriesModifyModal: false,
    detailInventory: null,

    resultType: '',
    logResult: '',
    showSystemAlert: false,
  }),
  computed: {
    customBoardLists() {
      this.boardLists.forEach((item, index) => {
        item.no = this.boardLists.length - index;
        item.modify = '수정';
      });
      return this.boardLists;
    },
  },
  methods: {
    async getMediaDetail() {
      try {
        const id = this.$route.params.id;
        const { data } = await detailMedia(id);
        const type = data.row.type;

        this.mediaType = type;
        this.options = data.row.options;
      } catch (error) {
        bus.$emit('end:spinner');
      }
    },
    async getListInventory() {
      try {
        const id = this.$route.params.id;
        const { data } = await listMediaInventories(id);
        const getListInventory = data.list;

        this.boardLists = getListInventory;
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
      }
    },
    async getDetailInventory(id) {
      bus.$emit('start:spinner');
      try {
        const { data } = await detailInventory(id);
        const getDetailInventory = data.row;

        this.detailInventory = getDetailInventory;
        this.detailOptoins = data.row.options;

        this.options.filter(item => {
          data.row.options.forEach(opt => {
            if (item.id !== opt.id) this.detailOptoinsNone.push(item);
          });
        });

        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
      }
    },

    async isValidPopup(item) {
      bus.$emit('start:spinner');
      try {
        const resultData = {
          is_valid: item.is_valid === 'Y' ? 'N' : 'Y',
        };

        const { data } = await updateInventory(item.id, resultData);
        if (data.result === 'success') {
          bus.$emit('end:spinner');
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = '지면 상태를 변경하였습니다.';
        }
      } catch (error) {
        bus.$emit('end:spinner');
        console.log('error.response', error.response);
      }
    },

    closePopup() {
      const type = this.resultType;
      this.showSystemAlert = false;
      if (type === 'success') {
        bus.$emit('start:spinner');
        this.getListInventory();
      }
    },
    optionTooltip(id) {
      let text = '';
      this.options.forEach(opt => {
        if (opt.id === id) text = opt.note;
      });
      return text;
    },
    choiceToggle() {
      const leng = this.holes.length;
      let num = 0;
      this.holes.map(v => {
        v.active ? num++ : num;
      });
      num === leng
        ? this.holes.map(v => {
            v.active = false;
          })
        : this.holes.map(v => {
            v.active = true;
          });
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.fileName = file.name;
    },
    onModifyPopup(inventories) {
      this.inventoriesProps = inventories;
      this.showMediaInventoriesModifyModal = true;
    },
    copyTestingCode(copyWord) {
      let testingCodeToCopy = document.querySelector('#testing-code');
      testingCodeToCopy.value = copyWord;
      testingCodeToCopy.setAttribute('type', 'text');
      testingCodeToCopy.select();

      try {
        document.execCommand('copy');
        this.showSystemAlert = true;
        this.logResult = '복사되었습니다.';
      } catch (err) {
        this.showSystemAlert = true;
        this.logResult = 'Oops, unable to copy';
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.getMediaDetail();
    this.getListInventory();
  },
};
</script>
